import React, {Component} from 'react';
import qs from 'qs';
import {EditorState, convertToRaw, ContentState} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../styles/formnews.css';
import { create as createNews, load as loadNews, edit as editNews, uploadImage as uploadNewsImage, getImageUrl } from '../services/newsService';
import ImageUploader from 'react-images-upload';
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Button,
  Snackbar,
  Alert,
  CircularProgress
} from '@mui/material';

class Formnews extends Component {
  constructor(props) {
    super(props);

    const html = '<p>Hey this <strong>editor</strong> rocks 😀</p>';
    const contentBlock = htmlToDraft(html);
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const editorState = EditorState.createWithContent(contentState);

    this.state = {
      editorState,
      pictures: [],
      language: '',
      subject: '',
      published: false,
      free: false,
      expert: false,
      custom: false,
      file: undefined,
      submitting: false,
      snackbar: { open: false, severity: 'success', message: '' }
    };

    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.queriesFormnews = this.queriesFormnews.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.closeSnackbar = this.closeSnackbar.bind(this);
  }

  async componentDidMount() {
    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    if (parsed.new_id && parsed.new_id !== 'undefined' && parsed.new_id.length > 0) {
      const New = await loadNews(parsed.new_id);
      const contentBlock = htmlToDraft(New.body || '<p></p>');
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      this.setState({
        language: New.language || '',
        subject: New.subject || '',
        editorState,
        published: !!New.published,
        free: !!New.free,
        expert: !!New.expert,
        custom: !!New.custom,
        file: New.file
      });
    }
  }

  closeSnackbar() {
    this.setState({ snackbar: { ...this.state.snackbar, open: false } });
  }

  onDrop(pictureFiles) {
    this.setState({ pictures: this.state.pictures.concat(pictureFiles) });
    uploadNewsImage(pictureFiles[0])
      .then((res) => {
        this.setState({ file: res._id, snackbar: { open: true, severity: 'success', message: 'Image uploadée.' } });
      })
      .catch(() => this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur upload image.' } }));
  }

  async queriesFormnews(event) {
    event.preventDefault();

    const bodyHtml = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())) || '';
    if (!this.state.subject || !this.state.language) {
      this.setState({ snackbar: { open: true, severity: 'warning', message: 'Language et Subject sont requis.' } });
      return;
    }

    const New = {
      language: this.state.language,
      subject: this.state.subject,
      body: bodyHtml,
      published: !!this.state.published,
      free: !!this.state.free,
      expert: !!this.state.expert,
      custom: !!this.state.custom,
    };
    if (this.state.file) New.file = this.state.file;

    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    const isEdit = parsed.new_id && parsed.new_id !== 'undefined' && parsed.new_id.length > 0;

    this.setState({ submitting: true });
    try {
      if (isEdit) {
        await editNews(parsed.new_id, New);
      } else {
        await createNews(New);
      }
      this.setState({ snackbar: { open: true, severity: 'success', message: 'News sauvegardée.' } });
      setTimeout(() => this.props.history.push(`/super-admin/Listenews`), 600);
    } catch (e) {
      this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur lors de l’enregistrement.' } });
    } finally {
      this.setState({ submitting: false });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  onEditorStateChange(editorState) {
    this.setState({ editorState });
  }

  render() {
    const { language, subject, published, free, expert, custom, file, submitting, snackbar } = this.state;

    return (
      <Box sx={{ p: 2 }}>
        <Paper variant="outlined" sx={{ p: 3, maxWidth: 900, mx: 'auto' }}>
          <Stack spacing={3}>
            <Typography variant="h6">{this.props.location?.search?.includes('new_id') ? 'Edit News' : 'Create News'}</Typography>

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              {file && (
                <Box sx={{ minWidth: 200 }}>
                  <img src={getImageUrl(file)} alt={file} style={{ maxWidth: '100%', borderRadius: 4 }} />
                </Box>
              )}
              <Box sx={{ flex: 1 }}>
                <ImageUploader
                  withIcon={true}
                  withPreview={true}
                  maxFileSize={2097152}
                  label={'Max file size: 2mb, accepted: jpg / png / gif, format: 102x102 or 430x102'}
                  buttonText='Choose images'
                  onChange={this.onDrop}
                  imgExtension={['.jpg', '.gif', '.png']}
                />
              </Box>
            </Stack>

            <Box component="form" onSubmit={this.queriesFormnews}>
              <Stack spacing={2}>
                <FormControl fullWidth required>
                  <InputLabel id="language-label">Language</InputLabel>
                  <Select
                    labelId="language-label"
                    name="language"
                    label="Language"
                    value={language || ''}
                    onChange={this.handleInputChange}
                  >
                    <MenuItem value=""><em>choose</em></MenuItem>
                    <MenuItem value="fr">Français</MenuItem>
                    <MenuItem value="en">Anglais</MenuItem>
                    <MenuItem value="zh">Chinois</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Subject"
                  name="subject"
                  value={subject || ''}
                  onChange={this.handleInputChange}
                  fullWidth
                  required
                />

                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Descriptions</Typography>
                  <Editor
                    editorState={this.state.editorState}
                    wrapperClassName="news-wrapper"
                    editorClassName="news-editor"
                    onEditorStateChange={this.onEditorStateChange}
                  />
                </Box>

                <Stack direction="row" spacing={2}>
                  <FormControlLabel control={<Checkbox checked={published || false} onChange={this.handleInputChange} name="published" />} label="Published" />
                  <FormControlLabel control={<Checkbox checked={expert || false} onChange={this.handleInputChange} name="expert" />} label="Expert" />
                  <FormControlLabel control={<Checkbox checked={custom || false} onChange={this.handleInputChange} name="custom" />} label="Custom" />
                  <FormControlLabel control={<Checkbox checked={free || false} onChange={this.handleInputChange} name="free" />} label="Free" />
                </Stack>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting}
                    startIcon={submitting ? <CircularProgress size={18} /> : null}
                  >
                    {submitting ? 'Saving...' : 'Save'}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Paper>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={this.closeSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default Formnews;